import { useEffect } from 'react'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import Button from '../../shared/components/Button/Button'

function ProviderFilterModal({ filters, onChange, onClear, onClose }) {

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar fornecedores</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">

                    <div className="fm-section">
                        <span className="fm-label">Tipo de pessoa</span>
                        <div className="fm-status-row">
                            {[
                                { value: 'all', label: 'Todos' },
                                { value: 'fisica', label: 'Física' },
                                { value: 'juridica', label: 'Jurídica' },
                            ].map(opt => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${filters.personType === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange('personType', opt.value)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ProviderFilterModal
